import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  ElementRef,
} from "@angular/core";
import { MatTable, PageEvent, MatDialog } from "@angular/material";
import { Practitioner } from "../../../core/model/v2/practitioner/practitioner";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { PhysicianOptionService } from "../../shared/physician-option/physician-option.service";
import {
  PractitionerFavoriteReq,
  PractitionerFavoriteRes,
} from "../../../core/model/v2/practitioner/practitionerFavoritesList";
import { Specialty } from "../../../core/model/v2/specialty";
import { CommonService } from "../../../core/services/v2/common.service";
import { SidebarPhysicianFavoritesComponent } from "../sidebar-physician-favorites/sidebar-physician-favorites.component";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { fromEvent, Observable, of } from "rxjs";
import { map, debounceTime, distinctUntilChanged, startWith, switchMap, tap } from "rxjs/operators";
import { PhysicianProfileComponent } from "../../profile/physician/physician-profile.component";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-physician-favorites",
  templateUrl: "./physician-favorites.component.html",
  styleUrls: ["./physician-favorites.component.scss"],
})
export class PhysicianFavoritesComponent implements OnInit, AfterViewInit {
  searchProvider: FormControl = new FormControl('');
  userId: number;
  toggleSidebar = false;
  sectionName: string = "addFavorite";

  searchCriteria: string = "";

  pageLength = 10;
  pageIndex = 1;
  dataLength;

  specialty: Specialty[];

  displayedColumns: string[] = [
    "physicianName",
    "dob",
    "gender",
    "specialty",
    "address",
    "phoneNumber",
    "fax",
    "actions",
  ]; //['patientName', 'contact', 'aptDateTime', 'nextAptDateTime', 'symptoms', 'action'];
  dataSource: PractitionerFavoriteRes[];
  role: string;
  selectedPractitioner: Practitioner;

  sideBarHeader: string = "Add Physician Favorite";

  @ViewChild(SidebarPhysicianFavoritesComponent, { static: false })
  childComponent: SidebarPhysicianFavoritesComponent;
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;
  
  providerFilteredOptions: Observable<any[]>;

  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private commonService: CommonService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.searchFavorite();
  }

  ngOnInit() {
    this.commonService.getSpecialty().subscribe(
      (response) => {
        this.specialty = response.specialties;
      },
      (error) => {
        console.error(error);
      }
    );
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.searchFavorite();
      },
      (error) => {
        console.error(error);
      }
    );
    this.providerFilteredOptions = this.searchProvider.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        if (!val) {
          return new Observable<any[]>();
        }
        return this._filter(val || '');
      })
    );

  }

  ngAfterViewInit() {
    this.searchFavorite();
  }

  private _filter(value: string): Observable<any[]> {
    const filterValue = value.toLowerCase();
    if (this.dataSource) {
      let data = this.dataSource.filter(option => option.practitionerName.toLowerCase().includes(filterValue));
      if (data && data.length > 0) {
        return of(data);
      }
    }

    const apiUrl = 'Practitioner/GetPractitionersByName?searchText=' + value;
    return this.commonService.getDynamicSearchApiData(apiUrl).pipe(
      tap(),
      map((response) => {
        return response.practitioners;
      })
    );
  }

  destroyChild() {
    this.childComponent.ngOnDestroy();
  }

  searchFavorite() {
    const self = this;
    this.loaderService.show();
    const searchReq: PractitionerFavoriteReq = new PractitionerFavoriteReq();
    searchReq.userId = self.physicianOptionService.getPhysician().id;
    searchReq.pageIndex = self.pageIndex;
    searchReq.itemsCount = self.pageLength;
    searchReq.type = "1";
    searchReq.criteria = this.searchCriteria;

    this.practiceService.searchPractitionerFavorites(searchReq).subscribe(
      (res) => {
        self.dataSource = res.practitioners;
        self.dataLength = res.practitionersTotalRecords;
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => { }
    );
  }

  deleteFavorite(favorite: PractitionerFavoriteRes) {
    Swal.fire({
      title: `Remove Favorite`,
      text: `Are you sure want to remove Dr. ${favorite.practitionerName} from your favorite?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Remove!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loaderService.blockWithLoader(this.practiceService.deletePractitionerFavorites(favorite.id)).subscribe(
          (_) => {
            this.dataSource = this.dataSource.filter((ds) => ds.id != favorite.id);
            this.dataLength = this.dataLength - 1;
            this.table.renderRows();
          },
          (error) => {
            console.error(error);
          },
          () => {
            this.loaderService.hide();
          }
        );
      }
    });
  }

  goToPractitioner(practitioner: any) {
    if (practitioner.practitionerId) {
      this.router.navigate(['/physician/profile', { id: practitioner.practitionerId, src: 'overview', fromPractitionerId: this.physicianOptionService.getPhysician().id }]);
    }
    else {
      this.router.navigate(['/physician/profile', { npi: practitioner.practitionerNPI, src: 'overview', fromPractitionerId: this.physicianOptionService.getPhysician().id }]);
    }
  }
}
